<template>
  <div class="fryPurchase">
    <div class="content-container">
      <div class="titieMian">
        <div class="title-container">苗种采购</div>
        <div class="select-container">
          <div class="select-container-box">
            <span>基地&nbsp;&nbsp;</span>
            <el-select v-model="fishBaseId" filterable placeholder="请选择" size="small" @change="baseChange">
              <el-option v-for="(item, index) in baseList" :key="index" :label="item.value" :value="item.key">
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box">
            <span>时间&nbsp;&nbsp;</span>
            <el-date-picker size="small" v-model="start" :clearable="false" type="date" placeholder="开始日期" value-format="yyyy-MM-dd" @change="changeTime(0)"
              :picker-options="pickerTimeOptions">
            </el-date-picker>
          </div>
          <div class="select-container-box" style="padding: 0 5px">
            <span>至</span>
          </div>
          <div class="select-container-box" style="padding: 0 1px">
            <el-date-picker size="small" v-model="end" type="date" :clearable="false" placeholder="结束日期" value-format="yyyy-MM-dd" @change="changeTime(1)"
              :picker-options="pickerTimeOptions">
            </el-date-picker>
          </div>
          <!-- <div class="select-container-box">
            <span>在&nbsp;&nbsp;</span>
            <el-select v-model="type" filterable size="small">
              <el-option v-for="(item, index) in typeList" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box">
            <span>查找&nbsp;&nbsp;</span>
            <el-input placeholder="请输入关键字" v-model="keyword" :maxlength="num" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" prefix-icon="el-icon-search"
              size="small" class="search-input" clearable>
            </el-input>
          </div> -->
          <el-popover class="pop-condition" placement="bottom" width="580" v-model="popoverVisible" trigger="click">
            <div class="condition">
              <section class="mask">
                <div class="popover-container-box">
                  <span class="popover-label">单据编号：</span>
                  <el-input placeholder="请输入" v-model="number" :maxlength="num" size="small" class="search-input" clearable>
                  </el-input>
                </div>
                <div class="popover-container-box">
                  <span class="popover-label">塘口：</span>
                  <el-input placeholder="请输入" v-model="pondNo" :maxlength="num" size="small" class="search-input" clearable>
                  </el-input>
                </div>
                <div class="popover-container-box">
                  <span class="popover-label">周期：</span>
                  <el-input placeholder="请输入" v-model="batch" :maxlength="num" size="small" class="search-input" clearable></el-input>
                </div>
                <div class="popover-container-box">
                  <span class="popover-label">苗种：</span>
                  <el-input placeholder="请输入" v-model="fish" :maxlength="num" size="small" class="search-input" clearable></el-input>
                </div>
                <div class="popover-container-box">
                  <span class="popover-label">供应商：</span>
                  <el-input placeholder="请输入" v-model="provider" :maxlength="num" size="small" class="search-input" clearable></el-input>
                </div>
                <div class="popover-container-box">
                  <span class="popover-label">制单人：</span>
                  <el-input placeholder="请输入" v-model="userName" :maxlength="num" size="small" class="search-input" clearable></el-input>
                </div>
              </section>
              <div class="comfirm">
                <span @click="popoverVisible = false">关闭</span>
                <span @click="search(1)">查询</span>
              </div>
            </div>
            <div class="more" slot="reference">更多条件</div>
          </el-popover>
          <audit-status :audit-status.sync="auditStatus" />
          <div class="select-container-box">
            <el-button size="small" type="info" plain @click="search(1)" class="query">查询</el-button>
            <el-button size="small" type="info" plain @click="goAdd" class="add" v-if="edit">增加</el-button>
            <!-- <el-button size="small"  type="info" plain @click="batchAuditOrder" class="query" style="width: auto;">批量审核</el-button> -->
            <ExportExcelBtn apiUrl="/api/FishPurchase/Export" :queryParamsObj="queryParams" fileName="鱼苗采购.xls" />
          </div>
        </div>
      </div>
      <div class="table-container">
        <el-table :highlight-current-row="false" :data="fryPurchaseList.list" style="width: 100%" size="medium" @row-dblclick="dataBackFillGoods" :summary-method="getSummaries"
          show-summary :default-sort="{ prop: 'date', order: 'descending' }">
          <i slot="empty" style="font-style: normal">该时间段暂无数据</i>
          <el-table-column type="expand">
            <template slot-scope="props">
              <c-descriptions>
                <c-descriptions-row v-for="(item, index) in props.row.detalis" :key="index" grid-template-columns="1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr">
                  <c-descriptions-item label="塘口">{{
                    item.pondName
                  }}</c-descriptions-item>
                  <c-descriptions-item label="周期">{{
                    item.batchNo
                  }}</c-descriptions-item>
                  <c-descriptions-item label="渔种">{{
                    item.fish
                  }}</c-descriptions-item>
                  <c-descriptions-item label="规格">{{
                    item.spec
                  }}</c-descriptions-item>
                  <c-descriptions-item label="计量单位">{{
                    item.measureUnit
                  }}</c-descriptions-item>
                  <c-descriptions-item label="数量">{{
                    item.detailQuantity
                  }}</c-descriptions-item>
                  <c-descriptions-item label="重量">{{
                    item.detailWeight
                  }}</c-descriptions-item>
                  <c-descriptions-item label="均重">{{
                    item.detailAvgWeight
                  }}</c-descriptions-item>
                  <c-descriptions-item label="单价">{{
                    item.detailUnitPriceTax
                  }}</c-descriptions-item>
                  <c-descriptions-item label="金额">{{
                    item.detailAmountTotal
                  }}</c-descriptions-item>
                  <c-descriptions-item label="调整金额">{{
                    item.detailAmountAdjust
                  }}</c-descriptions-item>
                  <c-descriptions-item label="结算金额">{{
                    item.detailFinalAmount
                  }}</c-descriptions-item>
                </c-descriptions-row>
              </c-descriptions>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="日期" width="70" show-overflow-tooltip :formatter="formatter" align="center">
          </el-table-column>
          <el-table-column prop="number" align="center" label="单据编号" width="130">
          </el-table-column>
          <el-table-column prop="fishBaseName" align="center" label="基地" >
          </el-table-column>
          <el-table-column prop="pondName" align="center" label="塘口" >
          </el-table-column>
          <el-table-column prop="totalQuantity" label="总数量" width="110" show-overflow-tooltip align="center" :formatter="$formatCellNumberKeepTwo">
          </el-table-column>
          <el-table-column prop="totalWeight" label="总重量" width="110" show-overflow-tooltip align="center" :formatter="$formatCellNumberKeepTwo">
          </el-table-column>
          <el-table-column prop="unitPriceTax" align="center" width="110" show-overflow-tooltip label="总均价" :formatter="$formatCellNumberKeepTwo">
          </el-table-column>
          <el-table-column prop="totalAmount" align="center" width="110" label="总金额" show-overflow-tooltip :formatter="$formatCellNumberKeepTwo">
          </el-table-column>
          <el-table-column prop="totalAmountAdjust" width="110" label="调整金额" show-overflow-tooltip align="center" :formatter="$formatCellNumberKeepTwo">
          </el-table-column>
          <el-table-column prop="finalAmount" label="结算金额(元)" width="110" show-overflow-tooltip align="center" :formatter="$formatCellNumberKeepTwo">
          </el-table-column>
          <el-table-column prop="custName" label="供应商" align="center" width="150" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="userName" label="制单人" show-overflow-tooltip width="50" align="center">
          </el-table-column>
          <el-table-column label="操作栏" align="center" width="150">
            <template slot-scope="scope">
              <!-- <span class="content-edit" v-if="scope.row.auditStatus === 0" @click="handleAuditStatus(scope.row)">审核</span> -->
              <span @click="handleEdit(scope.$index, scope.row)" class="content-edit" style="margin-left: 20px">{{ edit ? "编辑" : "查看" }}</span>
              <span @click="handleDelete(scope.$index, scope.row)" class="content-del" v-if="edit">删除</span>
              <!-- <span v-if="scope.row.auditStatus !== 0">已审核</span> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <page-change :pageInfo="pageInfo"></page-change>
    </div>
  </div>
</template>

<script>
import PageChange from "../../common/PageChange";
import AuditStatus from "@/components/AuditStatus";
import { mapState, mapActions } from "vuex";
import { modules } from "../../../store";
import { storage } from "../../../service/storage";
import checkPermission from "../../../service/checkPermission.js";
import mixins from "@/common/MixIn.js";
import { resolveFishBaseKeyFromList, fishBaseIdForQuery } from "@/common/resolveFishBaseSelection.js";
import ExportExcelBtn from "../../common/ExportExcelBtn";
export default {
  name: "fryPurchase",
  mixins: [mixins],
  components: {
    PageChange,
    AuditStatus,
    ExportExcelBtn,
  },
  data () {
    return {
      num: 20,
      popoverVisible: false,
      type: "",
      typeList: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "pondNo",
          label: "塘口",
        },
        // {
        //   value: "batch",
        //   label: "周期"
        // },
        {
          value: "fish",
          label: "苗种",
        },
        {
          value: "provider",
          label: "供应商",
        },
      ],
      fishBaseId: "", //基地
      baseList: [], //基地列表
      start: "", //开始时间
      end: "", //结束时间
      pondNo: "", //塘口
      batch:"",//周期
      fish: "", //苗种
      provider: "", //供应商
      number: "", //单据编号
      userName: "", //制单人
      pickerTimeOptions: {
        // 限制日期
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6;
        },
      },
      keyword: "", //查找
      pageInfo: {
        pageNumber: 1, // 当前页数
        totalPages: 0, // 总页数
        pageFunc: this.search, // 当前页数需要调用的函数
        pageSize: 10, // 当前页数
      },
      auditStatus: "", //审核状态 0-待审核 1-已审核
    };
  },
  methods: {
    ...mapActions(modules.fryPurchase, [
      "getFryPurchaseV2",
      "delFryPurchaseDetail",
      "delFryPurchase",
    ]),
    ...mapActions(modules.base, ["getAllBaseList"]), //基地
    ...mapActions(modules.auditOrder, [
      "auditFishOrder",
      "auditFishOrderByMouth",
    ]), // 审核
    //记住基地
    baseChange (e) {
      storage.set("base", e);
    },
    //存储选中时间
    changeTime (type) {
      if (type == 0) {
        storage.set("start", this.start);
      } else {
        storage.set("end", this.end);
      }
    },
    //双击进入编辑页面
    dataBackFillGoods (row, event) {
      // if(row.auditStatus !== 0) return
      this.$router.push({
        name: "addFryPurchase",
        query: {
          id: row.orderId,
        },
      });
    },
    filterHandler (value, row, column) {
      // 筛选过滤
      const property = column["property"];
      return row[property] === value;
    },
    // 格式化指定列时间
    formatter (row) {
      if (!row.date) {
        return false;
      }
      return this.$timeformatDay(row.date);
    },

    //合计
    getSummaries (param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if ([1, 2, 3, 4, 11, 12].indexOf(index) >= 0) {
          sums[index] = "--";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        } else {
          sums[index] = "--";
        }
      });

      let amount = parseFloat(sums[8]);
      let weight = parseFloat(sums[6]);
      sums[7] = weight == 0 ? 0 : (amount / weight).toFixed(2);

      return sums.map((item) => {
        if (typeof item === "number" && !isNaN(item)) {
          item = item.toFixed(2);
        }
        return item;
      });
    },
    //查询
    search (pageNum) {
      sessionStorage.setItem("purchaseKeyword", this.keyword);
      let obj = this.queryParams;
      obj.pageIndex = this.pageInfo.pageNumber = pageNum || 1;

      this.getFryPurchaseV2(obj)
        .then((rsp) => {
          if (rsp.status === 200) {
            this.pageInfo.totalPages = rsp.data.total;
          }
        })
        .catch((err) => {
          console.dir(err);
        });
      
      this.popoverVisible = false
    },
    goAdd () {
      //添加
      this.$router.push({
        name: "addFryPurchase",
        query: {
        },
      });

      // this.$route.meta = "添加鱼苗采购";
    },
    handleEdit (index, row) {
      //编辑
      this.$router.push({
        name: "addFryPurchase",
        query: {
          id: row.orderId,
        },
      });
    },
    handleLook (index, row) {
      //查看
      this.$router.push({
        name: "addFryPurchase",
        query: { id: row.orderId },
      });
    },
    //删除
    handleDelete (index, row) {
      let pageIndex = this.pageInfo.pageNumber;
      if (this.pageInfo.totalPages % 10 === 1) {
        pageIndex -= 1;
      }
      this.$confirm("是否删除此记录", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await this.delFryPurchase(row.orderId);
          this.search(pageIndex);
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch((err) => {
          this.$Alert.info({
            content: err.response.data,
            duration: 5000,
            status: "error",
          });
          // this.$message.error(err.response.data);
        });
    },
    // 审核
    async handleAuditStatus (row) {
      const confirmRes = await this.$confirm("确认审核通过该单据?").catch(
        (err) => err
      );
      if (confirmRes !== "confirm") return;
      await this.auditFishOrder({
        id: row.orderId,
        auditStatus: 1,
      }).catch((err) => {
        this.$Alert.info({
          content: err.response.data,
          duration: 5000,
          status: "error",
        });
      });
      this.search();
    },
    // 批量审核
    async batchAuditOrder () {
      const confirmRes = await this.$confirm("", "批量操作", {
        confirmButtonText: "批量审核",
        cancelButtonText: "批量驳回",
        center: true,
        distinguishCancelAndClose: true,
      }).catch((err) => err);
      if (confirmRes === "close") return;
      const auditStatus = confirmRes === "confirm" ? 1 : 0;
      const params = {
        auditStatus, // 审核状态 0-待审核 1-已审核 2-审核不通过
        fishStockAbstractId: 2000, // 苗种采购 = 2000 成鱼销售 = 2001
        fishBaseId: fishBaseIdForQuery(this.fishBaseId, this.baseList),
        startDate: this.start,
        endDate: this.end,
        fish: this.fish,
        provider: this.provider,
        number: this.number,
        userName: this.userName,
        batch: this.batch,
        pondNo: this.pondNo,
        pageIndex: 1, // 当前页数(从1开始)
        pageSize: 10000, // 分页条数
      };
      // if (this.type === "") {
      //   params.fish = this.keyword;
      //   params.provider = this.keyword;
      //   params.pondNo = this.keyword;
      //   params.batch = params.pondNo;
      // } else {
      //   params[this.type] = this.keyword;
      // }
      await this.auditFishOrderByMouth(params).catch((err) => {
        this.$Alert.info({
          content: err.response.data,
          duration: 5000,
          status: "error",
        });
      });
      this.search();
    },
  },
  async mounted () {
    // 记录查找关键字
    this.judgeSession("purchaseKeyword");
    this.keyword = this.word;

    this.baseList = await this.getAllBaseList({ forQueryAll: true });
    this.fishBaseId = resolveFishBaseKeyFromList(
      this.baseList,
      storage.get("base")
    );
    this.search(); //所有数据
  },
  //缓存路由组件重新被激活 事件，重新查询列表数据
  activated () {
    this.search(this.pageInfo.pageNumber);
  },
  computed: {
    ...mapState(modules.fryPurchase, ["fryPurchaseList"]),

    getPondFilterList () {
      const res = new Map();
      let fiterList = this.fryPurchaseList.list
        .map((m) => ({
          value: m.pondName,
          text: m.pondName,
        }))
        .filter((a) => !res.has(a.text) && res.set(a.text, 1));
      return fiterList;
    },
    getPeriodFilterList () {
      const res = new Map();
      let fiterList = this.fryPurchaseList.list
        .map((m) => ({
          value: m.batchNumber,
          text: m.batchNumber,
        }))
        .filter((a) => !res.has(a.text) && res.set(a.text, 1));
      return fiterList;
    },

    getFishFilterList () {
      const res = new Map();
      let fiterList = this.fryPurchaseList.list
        .map((m) => ({
          value: m.fish,
          text: m.fish,
        }))
        .filter((a) => !res.has(a.text) && res.set(a.text, 1));
      return fiterList;
    },
    queryParams () {
      let obj = {
        pageIndex: this.pageInfo.pageNumber || 1,
        pageSize: this.pageInfo.pageSize,
        fishBaseId: fishBaseIdForQuery(this.fishBaseId, this.baseList),
        startDate: this.start,
        endDate: this.end,
        fish: this.fish,
        provider: this.provider,
        number: this.number,
        userName: this.userName,
        batch: this.batch,
        pondNo: this.pondNo,
        AuditStatus: this.auditStatus, //审核状态 0-待审核 1-已审核
      };
      // if (this.type === "") {
      //   obj.fish = this.keyword;
      //   obj.provider = this.keyword;
      //   obj.pondNo = this.keyword;
      //   obj.batch = obj.pondNo;
      // } else {
      //   obj[this.type] = this.keyword;
      // }
      return obj;
    },
  },
  //默认时间
  created () {
    let startTime = storage.get("start");
    let endTime = storage.get("end");
    if (startTime) {
      this.start = startTime;
    } else {
      const start = new Date();
      start.setDate(1);
      this.start = this.$timeformatDay(start);
    }
    if (endTime) {
      this.end = endTime;
    } else {
      this.end = this.$timeformatDay(new Date());
    }
  },
};
</script>
<style lang="stylus" scoped>
.pop-condition {
  .more {
    margin-left: 20px;
    padding: 0 20px;
    line-height: 32px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 1), rgba(230, 230, 230, 1));
    border: 1px solid rgba(198, 198, 198, 1);
    border-radius: 4px;
    color: #333333;
    cursor: pointer;
  }
}

.el-popover {
  width: 580px !important;

  .unit {
    display: inline-block;
    line-height: 32px;
    width: 180px;
    text-align: left;
  }

  .condition {
    color: #333;
    font-size: 16px;

    .more {
      height: 32px;
      padding: 0 12px;
      border-radius: 5px;
      line-height: 32px;
      font-size: 14px;
      color: #333;
      cursor: pointer;
      background: linear-gradient(180deg, rgba(255, 255, 255, 1), rgba(230, 230, 230, 1));
      border: 1px solid rgba(198, 198, 198, 1);
    }
  }

  .mask {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 5px 20px 15px 20px;
    z-index: 20;
    font-size: 16px;
    color: #666;
    background: #fff;

    .more {
      margin-left: 20px;
    }

    .popover-container-box {
      width: 260px;
      margin-top: 15px;
      display: flex;

      .popover-label {
        width: 130px;
      }
    }

    .el-input__inner {
      height: 36px;
      width: 180px;
    }

    >div {
      &:nth-child(2n) {
        text-align: right;
        padding-left: 0;

        >span {
          width: 80px;
          text-align: right;
        }
      }
    }
  }

  .comfirm {
    text-align: center;
    font-size: 16px;

    >span {
      display: inline-block;
      width: 100px;
      margin: 15px 0;
      border: 1px solid #BBBBBB;
      border-radius: 4px;
      line-height: 36px;
      background: #fff;
      cursor: pointer;

      &:nth-child(2) {
        margin-left: 20px;
        border: 1px solid #3389FF;
        color: #fff;
        background: #3389FF;
      }
    }
  }
}
</style>
